/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPpvFollowUpMessageForm } from '../models/AddPpvFollowUpMessageForm';
import type { PpvFollowUpMessageResponseDto } from '../models/PpvFollowUpMessageResponseDto';
import type { PpvFollowUpMinutesRequestDto } from '../models/PpvFollowUpMinutesRequestDto';
import type { ToggleStateRequestDto } from '../models/ToggleStateRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PpvFollowUpMessagesRestControllerService {
    /**
     * @returns PpvFollowUpMessageResponseDto OK
     * @throws ApiError
     */
    public static editFollowUpMessage({
        creatorId,
        id,
        requestBody,
    }: {
        creatorId: number,
        id: number,
        requestBody: AddPpvFollowUpMessageForm,
    }): CancelablePromise<PpvFollowUpMessageResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/settings/ppv-follow-up-messages',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PpvFollowUpMessageResponseDto OK
     * @throws ApiError
     */
    public static addFollowUpMessage({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: AddPpvFollowUpMessageForm,
    }): CancelablePromise<PpvFollowUpMessageResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/ppv-follow-up-messages',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove PPV follow-up message
     * @returns void
     * @throws ApiError
     */
    public static removeFollowUpMessage({
        creatorId,
        id,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * id of a message
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/settings/ppv-follow-up-messages',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * PPV follow-up message bought but not replied
     * @returns void
     * @throws ApiError
     */
    public static apiToggleFollowUpMessagesBoughtNotReplied({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The toggle state request
         */
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/settings/ppv-follow-up-messages/toggle-bought-not-replied',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * PPV follow-up message toggle
     * @returns void
     * @throws ApiError
     */
    public static apiToggleFollowUpMessages({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The toggle state request
         */
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/ppv-follow-up-messages/toggle',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * PPV follow-up message not seen toggle
     * @returns void
     * @throws ApiError
     */
    public static apiToggleFollowUpMessagesNotSeen({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The toggle state request
         */
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/ppv-follow-up-messages/toggle-not-seen',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * PPV follow-up message minutes toggle
     * @returns void
     * @throws ApiError
     */
    public static apiSetFollowUpMessagesMinutes({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The toggle state request
         */
        requestBody: PpvFollowUpMinutesRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/ppv-follow-up-messages/minutes',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
}
